import React from 'react';
import Header from './Header';

const styles = {
  container: {
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
  },
  header: {
    color: '#333',
    marginBottom: '10px',
  },
  subHeader: {
    color: '#666',
    marginBottom: '5px',
  },
  text: {
    color: '#999',
    marginBottom: '15px',
  },
};

const PrivacyPolicy = () => {
  return (
    <><Header /><div style={styles.container}>
          <h1 style={styles.header}>Privacy Policy</h1>
          <p style={styles.text}>
              This is the Privacy Policy for our website. It explains how we collect, use, and protect your personal information.
          </p>
          <h2 style={styles.subHeader}>Information We Collect</h2>
          <p style={styles.text}>
              We collect information that you provide to us when you register on our website, place an order, subscribe to our newsletter, respond to a survey or fill out a form.
          </p>
          <h2 style={styles.subHeader}>How We Use Your Information</h2>
          <p style={styles.text}>
              We use the information we collect from you in various ways, such as to personalize your experience, to improve our website, to improve customer service, to process transactions, and to send periodic emails.
          </p>
          <h2 style={styles.subHeader}>How We Protect Your Information</h2>
          <p style={styles.text}>
              We implement a variety of security measures to maintain the safety of your personal information when you enter, submit, or access your personal information.
          </p>
      </div></>
  );
};

export default PrivacyPolicy;